export const ALL_WARNINGS = {
  deleteForbiddenLo: {
    title: 'dashboard.lists.warning.delete.forbidden_loan_officers.title',
    description: 'dashboard.lists.warning.delete.forbidden_loan_officers.description',
  },
  deleteLo: { title: '', description: 'dashboard.lists.warning.delete.loan_officers' },
  deleteList: { title: '', description: 'dashboard.lists.warning.delete.list.description' },
  syncLo: { title: '', description: 'dashboard.lists.warning.sync.error.loan_officers' },
  syncList: { title: '', description: 'dashboard.lists.warning.sync.error.list' },
  favoriteList: { title: '', description: 'dashboard.lists.warning.favorite' },
  unfavoriteList: { title: '', description: 'dashboard.lists.warning.unfavorite' },
  masquerade: { title: '', description: 'dashboard.user.masquerade_warning' },
};
